import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_invoice,
  get_invoice,
  update_invoice,
} from "../../../../Controllers/Sales/Invoices";
import forms from "../../../../Data/Forms/Sales/Invoices/forms";
import headers from "../../../../Data/Forms/Billings/Billings/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import BillingView from "../../../Billings/Billings/View";
import BillingPos from "../../../../Data/Forms/Billings/Billings/pos";
import BillingForm from "../../../../Data/Forms/Billings/Billings/forms";
import BillingIcon from "../../../../Assets/Svg/billing";
import SalesIcon from "../../../../Assets/Svg/sales";

const BillingsFormSales = () => {
  let { id } = useParams();
  let location = useLocation();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);
  const [header, setHeader] = useState(headers);
  const isEdit = !!id;

  const onSubmit = (e) => {
    e?.preventDefault();
  };
  const [customer, setCustomer] = useState();
  const [refrence, setReference] = useState();

  const [options, setOptions] = useState();
  const [details, setDetails] = useState([]);
  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    delivery: 0,
    delivery_status: 2,
    delivery_date: new Date(),
    payment_status: 2,
    payment_types: ["Cash"],
    /* payments: {
      Cash: "",
      Cheque: "",
      "Debit card": "",
      "Credit card": "",
      "Bank transfer": "",
      "Online payment": "",
    }, */
    payments: [{
      id: `temp-cash-initial`,
      name: "Cash",
      amount: ""
    }],
    paid: 0,
    remaining: 0,
    total: "0.000",
  });

  const formdata = async (data) => {

    if (buttonLoader) return;

    if (data?.status) {
      if (details?.length > 0) {
        let details_count = 0;
        details?.map((v, i) => {
          if (v?.unit) {
            details_count++;
          }
        });

        if (details?.length == details_count) {
          if (totals?.payment_types?.length > 0) {
            setButtonLoader(true);

            /*  let paymenttypedata = totals?.payment_types;
             let paymentdata = totals?.payments;
 
             if (totals?.payment_types?.length == 1) {
               paymenttypedata = [totals?.payment_types[0]];
               paymentdata = {};
               if (totals.payment_types[0] == "Cash") {
                 paymentdata = {
                   Cash: { amount: totals?.total },
                   Cheque: "",
                   "Debit card": "",
                   "Credit card": "",
                   "Bank transfer": "",
                   "Online payment": "",
                 };
               } else if (totals.payment_types[0] == "Cheque") {
                 paymentdata = {
                   Cash: "",
                   Cheque: { amount: totals?.total },
                   "Debit card": "",
                   "Credit card": "",
                   "Bank transfer": "",
                   "Online payment": "",
                 };
               } else if (totals.payment_types[0] == "Debit card") {
                 paymentdata = {
                   Cash: "",
                   Cheque: "",
                   "Debit card": { amount: totals?.total },
                   "Credit card": "",
                   "Bank transfer": "",
                   "Online payment": "",
                 };
               } else if (totals.payment_types[0] == "Credit card") {
                 paymentdata = {
                   Cash: "",
                   Cheque: "",
                   "Debit card": "",
                   "Credit card": { amount: totals?.total },
                   "Bank transfer": "",
                   "Online payment": "",
                 };
               } else if (totals.payment_types[0] == "Bank transfer") {
                 paymentdata = {
                   Cash: "",
                   Cheque: "",
                   "Debit card": "",
                   "Credit card": "",
                   "Bank transfer": { amount: totals?.total },
                   "Online payment": "",
                 };
               } else if (totals.payment_types[0] == "Online payment") {
                 paymentdata = {
                   Cash: "",
                   Cheque: "",
                   "Debit card": "",
                   "Credit card": "",
                   "Bank transfer": "",
                   "Online payment": { amount: totals?.total },
                 };
               } else {
                 paymentdata = {
                   Cash: "",
                   Cheque: "",
                   "Debit card": "",
                   "Credit card": "",
                   "Bank transfer": "",
                   "Online payment": "",
                 };
               }
             }
 
             let total_payment = 0;
             paymenttypedata?.map((v) => {
               total_payment =
                 parseFloat(total_payment || 0) +
                 parseFloat(paymentdata[v]?.amount || 0);
             });
 
             console.log(totals?.total, "totals?.total", paymenttypedata); */

            let paymentdata = totals?.payments?.filter(p => p.amount && parseFloat(p.amount) > 0) || [];

            let total_payment = paymentdata.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);


            if (
              parseFloat(parseFloat(total_payment || 0)?.toFixed(3)) ==
              parseFloat(parseFloat(totals?.total || 0)?.toFixed(3))
            ) {
              const invoice = id
                ? await update_invoice({
                  ...data?.data,
                  id: id,
                  customer: customer,
                  refrence: refrence,
                  date: new Date(),
                  // due_date: new Date(),
                  due_date: "",
                  details: details,
                  subtotal: totals?.subtotal,
                  taxamount: totals?.taxamount,
                  discount: totals?.discount,
                  delivery: totals?.delivery,
                  delivery_status: 2,
                  delivery_date: new Date(),
                  payment_status: 2,
                  payment_types: totals?.payment_types,
                  payments: paymentdata,
                  total: totals?.total,
                  source: "Sales"
                })
                : await create_invoice({
                  ...data?.data,
                  customer: customer,
                  refrence: refrence,
                  date: new Date(),
                  // due_date: new Date(),
                  due_date: "",
                  details: details,
                  subtotal: totals?.subtotal,
                  taxamount: totals?.taxamount,
                  discount: totals?.discount,
                  delivery: totals?.delivery,
                  delivery_status: totals?.delivery_status,
                  delivery_date: totals?.delivery_date,
                  payment_status: totals?.payment_status,
                  payment_types: totals?.payment_types,
                  payments: paymentdata,
                  status: 1,
                  total: totals?.total,
                  source: "Sales"
                });
              if (invoice?.status) {
                if (id) {
                  navigate(-1);
                }
                toast?.success(invoice?.message);
                setDetails([]);
                setTotals({
                  subtotal: "0.000",
                  taxamount: "0.000",
                  discount: 0,
                  delivery: 0,
                  delivery_status: 2,
                  delivery_date: new Date(),
                  payment_status: 2,
                  payment_types: ["Cash"],
                  /*  payments: {
                     Cash: "",
                     Cheque: "",
                     "Debit card": "",
                     "Credit card": "",
                     "Bank transfer": "",
                     "Online payment": "",
                   }, */
                  payments: [],
                  paid: 0,
                  remaining: 0,
                  total: "0.000",
                });
                setButtonLoader(false);
              } else {
                toast?.error(invoice?.message);
                setButtonLoader(false);
              }
            } else {
              toast?.error("Amount not paid");
              setButtonLoader(false);
            }
          } else {
            toast?.error("Select payment mode");
          }
        } else {
          toast?.error(`Unit missing item ${details_count}`);
        }
      } else {
        toast?.error("Add Items");
      }
    }
  };

  const handleData = (invoice) => {
    let customer = invoice?.customer?._id ? invoice?.customer?._id : null;
    let number = invoice?.number ? invoice?.number : "";
    let date = invoice?.date ? invoice?.date : "";
    let due_date = invoice?.due_date ? invoice?.due_date : "";
    let status = invoice?.status ? invoice?.status : 0;

    let customer_option = invoice?.customer?._id
      ? [
        {
          value: invoice?.customer?._id,
          label: invoice?.customer?.name,
        },
      ]
      : null;

    values[0].options[0].form.value = customer;
    values[0].options[0].form.options = customer_option;
    values[0].options[1].form.value = number;
    values[0].options[2].form.value = date;
    values[0].options[3].form.value = due_date;
    values[0].options[4].form.value = status;

    let data = [];
    invoice?.details?.map((value, index) => {
      data?.push({
        id: value?._id,
        description: value?.description?._id,
        options: [
          {
            value: value?.description?._id,
            label: value?.description?.product?.name,
          },
        ],
        unit: value?.unit,
        sale_price: value?.sale_price,
        quantity: value?.quantity,
        delivered: value?.delivered,
        discount: value?.discount,
        delivery: value?.delivery,
        tax: value?.tax,
        total: value?.total,
      });
    });

    let payment_types = [];
    let payments = [];

    invoice?.payments?.forEach((payment) => {
      if (!payment_types.includes(payment?.name)) {
        payment_types.push(payment?.name);
      }

      payments.push({
        id: payment?._id || `temp-cash-initial`,
        name: payment?.name,
        amount: payment?.amount
      });
    });

    totals.subtotal = invoice?.subtotal;
    totals.taxamount = invoice?.taxamount;
    totals.discount = invoice?.discount;
    totals.delivery = invoice?.delivery;
    totals.delivery_status = invoice?.delivery_status;
    totals.delivery_date = invoice?.delivery_date;
    totals.payment_status = invoice?.payment_status;
    /* totals.payment_types = JSON?.parse(invoice?.payment_types);
    totals.payments = JSON?.parse(invoice?.payments); */
    totals.payment_types = payment_types;
    totals.payments = payments;
    totals.paid = invoice?.paid;
    totals.remaining = invoice?.remaining;
    totals.total = invoice?.total;

    setValues([...values]);
    setDetails([...data]);
    setTotals({ ...totals });
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const invoice = await get_invoice(data);
      if (invoice?.status) {
        handleData(invoice?.data);
      } else {
        toast?.error(invoice?.message);
      }
    } else {
      // setLoader(false);
      values[0].options[2].form.value = new Date();
      // values[0].options[3].form.value = new Date();

      totals.delivery_status = 2;
      totals.delivery_date = new Date();
      totals.payment_status = 2;
      totals.payment_types = ["Cash"];

      setValues([...values]);
      setTotals({ ...totals });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        {!isEdit && (<div className="fixed top-56 right-8 transform -translate-y-1/2 z-50">
          <div className="flex rounded-md border border-gray-300 bg-white ">
            <button
              className={
                location?.pathname == "/app/billing/add"
                  ? "p-2 text-white bg-green-500 block"
                  : "p-2 text-green-500 hover:bg-gray-50 block"
              }
              onClick={() => navigate("/app/billing/add")}
            >
              <BillingIcon />
            </button>
            <button
              className={
                location?.pathname == "/app/billing/new/add"
                  ? "p-2 text-white bg-green-500 block"
                  : "p-2 text-green-500 hover:bg-gray-50 block"
              }
              onClick={() => navigate("/app/billing/new/add")}
            >
              <SalesIcon />
            </button>
          </div>
        </div>
        )}

        <BillingForm
          customer={customer}
          setCustomer={setCustomer}
          refrence={refrence}
          setReference={setReference}
        />
      </Loadercomponent>
    </Header>
  );
};

export default BillingsFormSales;
